import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { useColumns } from "../../context/useColumnsContext.js";
import { useVirtualizedTableProps } from "../../context/useVirtualizedTableProps.js";
import styled from "styled-components";
import { StickyFooterWrapper } from "./Styles.js";
const FooterCellWrapper = styled.div`
  border-color: var(--colors-tt-cell-border);
  border-width: 0;
  background: var(--colors-tt-table-background);
  border-right-width: 0.5px;
  border-top-width: 0.5px;
  flex-shrink: 0;
`;
const FooterCell = ({
  pinnedColumnsCount,
  children,
  renderIndex,
  offset,
  width,
  height,
  isPinned,
  cellOffset
}) => {
  let paddingLeft = 0;
  let styleWidth = width;
  let position = "static";
  let left = 0;
  let borderRightWidth = void 0;
  if (renderIndex === 0) {
    paddingLeft = offset;
    styleWidth = width + offset + 0.5;
  }
  if (isPinned) {
    position = "sticky";
    left = cellOffset;
  }
  if (pinnedColumnsCount === 1 && renderIndex === 0) {
    styleWidth = width + offset + 1;
    borderRightWidth = 1;
  } else {
    if (pinnedColumnsCount > 0 && renderIndex === 0) {
      styleWidth = width + offset + 0.5;
    }
    if (renderIndex > 0 && renderIndex < pinnedColumnsCount - 1) {
      left += 0.5;
    }
    if (pinnedColumnsCount - 1 === renderIndex) {
      styleWidth += 0.5;
      left += 0.5;
      borderRightWidth = 1;
    }
    if (pinnedColumnsCount > 0 && pinnedColumnsCount === renderIndex) {
      styleWidth -= 0.5;
    }
  }
  const style = {
    left,
    width: styleWidth,
    height,
    paddingLeft,
    borderRightWidth,
    position
  };
  return /* @__PURE__ */ jsx(FooterCellWrapper, { style, children });
};
const TableFooter = ({
  columns,
  offset,
  decorateFooterCell,
  height
}) => {
  const FooterCellComponent = decorateFooterCell;
  const { itemData } = useVirtualizedTableProps();
  const { getAbsoluteColumnIndex } = useColumns();
  const reorderedColumns = useMemo(() => {
    return [
      ...itemData.pinnedColumns.map((pinnedIndex) => columns[pinnedIndex]),
      ...columns.filter((_, index) => !itemData.pinnedColumns.includes(index))
    ];
  }, [itemData.pinnedColumns, columns]);
  let cellOffset = 0;
  return /* @__PURE__ */ jsx(StickyFooterWrapper, { offset, children: reorderedColumns.map((column, index) => {
    if (column.index === void 0) {
      return null;
    }
    const footerCell = /* @__PURE__ */ jsx(
      FooterCell,
      {
        pinnedColumnsCount: itemData.pinnedColumns.length,
        renderIndex: index,
        width: itemData.columnStyles[index].width,
        height,
        offset,
        cellOffset,
        isPinned: itemData.pinnedColumns.includes(
          getAbsoluteColumnIndex(index)
        ),
        children: /* @__PURE__ */ jsx(FooterCellComponent, { column })
      },
      column.value
    );
    if (index === 0) {
      cellOffset += offset;
    }
    cellOffset += itemData.columnStyles[index].width;
    return footerCell;
  }) });
};
export {
  TableFooter as default
};
